import { useContext } from 'react';
import { StatisticDashboard } from './StatisticDashboardProvider';

export default function useStatisticDashboardContext() {
    return useContext(StatisticDashboard);
};
